// File: /src/components/clients/ClientsListView.js

import React from 'react';
import ClientsList from '../ClientsList';

const ClientsListView = ({
	clients,
	selectedClients,
	cardColors,
	onToggleClient,
	onColorChange,
	onOpenClientModal,
}) => (
	<ClientsList
		clients={clients}
		selectedClients={selectedClients}
		cardColors={cardColors}
		toggleSelectClient={onToggleClient}
		handleColorChange={onColorChange}
		openClientModal={onOpenClientModal}
	/>
);

export default ClientsListView;
